<div class="flex flex-col gap-6">
  <div class="flex items-center">
    <div class="flex flex-col flex-1">
      <h3 class="text-on-surface dark:text-on-surface-darkmode font-semibold">
        {{ 'cockpit.supplierContracts.check.title' | transloco }}
      </h3>
      <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
        {{ 'cockpit.supplierContracts.check.subtitle' | transloco }}
      </p>
    </div>
    <div class="flex-none flex gap-3 items-center">
      @if (allLoading()) {
        <ui-skeleton class="block h-10 w-40 rounded-md" />
      } @else if (!error()) {
        @if (checks().length > 0) {
          @switch (status()) {
            @case ('IN_PROGRESS') {
              <ui-toggle-label *hasRole="['USER_ADMIN']">
                <ui-toggle [formField]="viewSettingsForm.showPreview" />
                {{ 'cockpit.supplierContracts.check.preview' | transloco }}
              </ui-toggle-label>
              <ui-button
                mode="outlined"
                (click)="onClickDelete(latestCheck().id)"
                [loading]="isDeleteLoading()"
                [disabled]="isDeleteLoading()"
                *hasRole="['USER_ADMIN']"
              >
                <span slot="start" class="text-error dark:text-error-darkmode">
                  <ng-icon name="heroTrash" size="20" class="!block" />
                </span>
                <span class="text-error dark:text-error-darkmode">
                  {{ 'cockpit.supplierContracts.check.delete' | transloco }}
                </span>
              </ui-button>
              <ui-button
                (click)="onClickPublish()"
                [loading]="isPublishLoading()"
                [disabled]="isPublishLoading()"
                *hasRole="['USER_ADMIN']"
              >
                <ng-icon name="heroPaperAirplane" slot="start" size="20" class="!block" />
                {{ 'cockpit.supplierContracts.check.publish' | transloco }}
              </ui-button>
            }
            @case ('DONE') {
              <ui-button
                mode="admin"
                (click)="onClickReopen()"
                [loading]="isUpdateLoading()"
                [disabled]="isUpdateLoading()"
                *hasRole="['USER_ADMIN']"
              >
                {{ 'cockpit.supplierContracts.check.edit' | transloco }}
              </ui-button>
            }
          }
        } @else {
          <ui-button
            (click)="onClickCreateCheck()"
            [loading]="isCreateLoading()"
            [disabled]="isCreateLoading()"
            *hasRole="['USER_ADMIN']"
          >
            <ng-icon name="heroPlus" size="20" slot="start" class="!block" />
            {{ 'cockpit.supplierContracts.check.createButton' | transloco }}
          </ui-button>
        }
      }
    </div>
  </div>
  @if (createError()) {
    <app-http-error [error]="createError()" class="block text-end empty:hidden">
      <ui-alert color="error" [titleOnly]="true">
        <span slot="title"> {{ 'cockpit.supplierContracts.check.createError' | transloco }} </span>
      </ui-alert>
    </app-http-error>
  }
  @if (deleteError()) {
    <app-http-error [error]="deleteError()" class="block text-end empty:hidden">
      <ui-alert color="error" [titleOnly]="true">
        <span slot="title"> {{ 'cockpit.supplierContracts.check.deleteError' | transloco }} </span>
      </ui-alert>
    </app-http-error>
  }
  @if (publishError()) {
    <app-http-error [error]="publishError()" class="block text-end empty:hidden">
      {{ 'cockpit.supplierContracts.check.publishError' | transloco }}
    </app-http-error>
  }
  @if (allLoading()) {
    <app-supplier-contract-check-skeleton />
  } @else if (error()) {
    <app-error-page
      [error]="error()"
      (clickBack)="router.navigate(['/organizations', organizationId(), 'supplier-contracts'])"
      class="block"
      style="height: calc(100vh - 30rem)"
    />
  } @else if (checks().length === 0) {
    <div
      class="border border-outline dark:border-outline-darkmode border-dashed rounded-lg py-5 px-6 text-center"
      *hasRole="['USER_ADMIN']"
    >
      <ui-button
        mode="outlined"
        (click)="onClickCreateCheck()"
        [loading]="isCreateLoading()"
        [disabled]="isCreateLoading()"
      >
        <ng-icon name="heroPlus" size="20" slot="start" class="!block" />
        {{ 'cockpit.supplierContracts.check.createButton' | transloco }}
      </ui-button>
    </div>
    <div
      class="border border-outline dark:border-outline-darkmode border-dashed rounded-lg py-5 px-6 text-center text-on-surface-disabled dark:text-on-surface-disabled-darkmode"
      *notHasRole="['USER_ADMIN']"
    >
      {{ 'cockpit.supplierContracts.check.notFound' | transloco }}
    </div>
  } @else {
    @if (latestCheck().data; as data) {
      @switch (status()) {
        @case ('IN_PROGRESS') {
          @if (viewSettings().showPreview) {
            <app-supplier-contract-check [data]="data" [organizationId]="organizationId()" />
          } @else {
            <app-supplier-contract-check-edit-form
              [data]="data"
              [organizationId]="organizationId()"
              (changeData)="onChangeFormData($event)"
              *hasRole="['USER_ADMIN']"
            />
            <div
              class="border border-outline dark:border-outline-darkmode border-dashed rounded-lg py-5 px-6 text-center text-on-surface-disabled dark:text-on-surface-disabled-darkmode"
              *notHasRole="['USER_ADMIN']"
            >
              {{ 'cockpit.supplierContracts.check.notFound' | transloco }}
            </div>
          }
        }
        @case ('DONE') {
          <app-supplier-contract-check [data]="data" [organizationId]="organizationId()" />
        }
      }
    }
  }
</div>
